import { render, staticRenderFns } from "./tbkpytFhxsc.vue?vue&type=template&id=22e266fd&scoped=true&"
import script from "./tbkpytFhxsc.vue?vue&type=script&lang=js&"
export * from "./tbkpytFhxsc.vue?vue&type=script&lang=js&"
import style0 from "./tbkpytFhxsc.vue?vue&type=style&index=0&id=22e266fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e266fd",
  null
  
)

export default component.exports